import React from 'react';

type SubsCriptxProps = {
  height?: string;
  width?: string;
};

function SubsCriptx({ height = '18', width = '18' }: SubsCriptxProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.9225 7L6.46094 14M6.46094 7L12.9225 14'
        stroke='black'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M17.0624 16.6882H19.8095V17.8184H14.7695V17.494C15.8727 16.2898 16.6694 15.3904 17.1597 14.7955C17.6537 14.2007 17.9799 13.75 18.1385 13.4436C18.3008 13.1335 18.3819 12.8271 18.3819 12.5243C18.3819 12.1998 18.2791 11.9384 18.0737 11.7401C17.8718 11.5419 17.605 11.4427 17.2733 11.4427C16.9272 11.4427 16.6478 11.5455 16.4351 11.751C16.226 11.9528 16.1215 12.216 16.1215 12.5405V12.7027H14.9264V12.5351C14.9264 11.8717 15.1409 11.3364 15.5699 10.929C15.9989 10.518 16.5631 10.3125 17.2625 10.3125C17.9475 10.3125 18.5063 10.5198 18.9389 10.9344C19.3715 11.3454 19.5878 11.8735 19.5878 12.5189C19.5878 12.8613 19.5265 13.1912 19.404 13.5085C19.2814 13.8257 19.038 14.2367 18.6739 14.7414C18.3098 15.2425 17.7726 15.8915 17.0624 16.6882Z'
        fill='black'
      />
    </svg>
  );
}

export default SubsCriptx;
